import { Logger } from "../logger/logger";
import { DialogResultVm } from "../checkresultdialog/dialogresultvm";
import { CheckResultData } from "../checkresultdialog/checkresultdata";

export class ErrorHelper {
	private static errorsHandled = false;

	public static readonly toString = (err: any) => {
		if (err == null) {
			return "-";
		} else if (typeof err === "string") {
			return err;
		} else {
			return JSON.stringify(err);
		}
	}

	public static readonly handleError = (suppressErrorAlert = true) => {
		if (ErrorHelper.errorsHandled) {
			Logger.warn("Global error handling already registered.");
			return;
		}

		ErrorHelper.errorsHandled = true;

		let errorFn: any = (msg: any, url: any, line: any, col: any, error: any) => {
			Logger.error({ msg, url, line, col, error });

			let data = new CheckResultData();
			data.error = error;
			data.success = false;
			data.highestLevel = 8;
			data.title = "Es ist ein Fehler aufgetreten";
			data.errorList = [
				"Nachricht: " + (msg || ""),
				"Fehlertyp: " + (error || ""),
				"Url: " + (url || ""),
				"Zeile: " + (line || ""),
				"Spalte: " + (col || ""),
			];

			DialogResultVm.showDialog(data, $.noop, $.noop);
			return suppressErrorAlert;
		};

		window.onerror = errorFn;

		jQuery.readyException = (error) => {
			if (error) {
				errorFn(error.message, "jQuery.ready", null, null, error);
			}
		};
	}
}